export default __webpack_public_path__ + "static/media/in2.34b4a5e0.jpg";